import { Component, Input, OnInit } from "@angular/core";
import { AuthService } from "src/app/services/auth.service";
import { CursosService } from "src/app/services/cursos.service";
import { AlertController, ModalController } from "@ionic/angular";
import { Router } from "@angular/router";
import { CalificaCursoComponent } from "../califica-curso/califica-curso.component";

@Component({
  selector: "app-certificados",
  templateUrl: "./certificados.component.html",
  styleUrls: ["./certificados.component.scss"],
})
export class CertificadosComponent implements OnInit {
  @Input() public curso: any;
  @Input() public perfil: any;
  private id: number;
  private auth_key: string;
  displayUserData: any;
  dataCurso: any;
  idCer: number;
  certificado: any = null;

  constructor(
    private cursosService: CursosService,
    private authService: AuthService,
    private alertCtrl: AlertController,
    private router: Router,
    private modalCtrl: ModalController
  ) {}

  ngOnInit() {
    console.log("constructor", this.curso);
    this.authService.userData$.subscribe((res: any) => {
      if (!this.displayUserData) {
        console.log(res);
        this.displayUserData = res;
        this.loadVariables();
      }
    });
  }

  selectCertificate(pos) {
    let allOpt = document.getElementsByName("cer");
    this.idCer = pos;
    for (let i = 0; i < allOpt.length; i++) {
      allOpt[i].classList.remove("active");
    }
    if (document.getElementsByName("cer")[pos]) {
      document.getElementsByName("cer")[pos].classList.add("active");
    }
  }

  loadVariables() {
    this.id = this.displayUserData?.id;
    this.auth_key = this.displayUserData?.auth_key;
    this.getCurso();
  }

  getCurso() {
    this.cursosService
      .getCursoById(this.id, this.auth_key, this.curso.id, this.curso.id_user)
      .subscribe((response) => {
        console.log(
          "🚀 ~ CertificadosComponent ~ .subscribe ~ response:",
          response
        );
        this.dataCurso = response;
        console.log(
          "file: certificados.component.ts:62 >> dataCurso:",
          this.dataCurso
        );
        this.selectCertificate(this.dataCurso.data.cod_certificado);
        this.getCursoEstudiante();
      });
  }

  updateCurso() {
    this.dataCurso.data.cod_certificado = this.idCer;
    this.dataCurso.data.idcurso = this.dataCurso.data.id;
    this.cursosService
      .updateCertificate(this.id, this.auth_key, null, this.dataCurso.data)
      .subscribe((res: any) => {
        this.saveAllMsg();
      });
  }

  getCursoEstudiante() {
    this.dataCurso.data.cod_certificado = this.idCer;
    this.dataCurso.data.idcurso = this.dataCurso.data.id;
    this.cursosService
      .getCertificate(this.id, this.auth_key, this.curso.id, this.id)
      .subscribe((res: any) => {
        console.log(
          "file: certificados.component.ts:78 >> getCursoEstudiante:",
          res
        );
        this.certificado = res;
        console.log(
          "🚀 ~ CertificadosComponent ~ .subscribe ~  this.certificado :",
          this.certificado
        );
      });
  }

  verCertificado() {
    this.router.navigate(["./certificado"], {
      queryParams: {
        curso: this.dataCurso.data.nombre,
        nombre: this.displayUserData.nombre_apellido,
        profesor: this.dataCurso.data.titulo_user,
        cer: this.dataCurso.data.cod_certificado ?? 0,
      },
    });
  }

  async calificaCurs() {
    const modal = await this.modalCtrl.create({
      component: CalificaCursoComponent,
      cssClass: "my-calif-curs",
      componentProps: { course: this.curso },
    });

    modal.onDidDismiss().then((dataReturned) => {});

    return await modal.present();
  }

  async saveAllMsg() {
    const alert = await this.alertCtrl.create({
      header: "Información",
      subHeader: "",
      message: "¡Certificado seleccionado con éxito!",
      buttons: [
        {
          text: "Aceptar",
          handler: () => {
            this.getCurso();
          },
        },
      ],
    });
    await alert.present();
  }
}
